import React, { useState, useRef } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  FormControl,
  IconButton,
  Radio,
  TablePagination,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { formatDateTimeForBackend } from "../../../Functions";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TreasurTable from "../Tables/Treasure_Table";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// import FormControlLabel from "@material-ui/core/FormControlLabel";

import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
const useStyles = makeStyles(dashboardStyle);

const TreasuryReview = () => {
  const navigate = useNavigate();

  const [batchActivation, setBatchActivation] = useState("Active Batches");
  const [treasureList, settreasureList] = useState([0]);
  const [invoiceLoading, setInvoiceLoading] = useState(true);
  const [count, setCount] = useState(0);

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const [formState, setFormState] = useState({
    BatchFromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    BatchToDate: moment().format("YYYY-MM-DD"),
    PageNo: 1,
    RowsOfPage: 25,
  });

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };
  return (
    <Card>
      <CardHeader>
        <CardHeader color="primary" text>
          <CardText color="primary" style={{ padding: "0px 27px" }}>
            <Grid container justifyContent="space-between">
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <h4>Treasury Review Screen</h4>
              </Grid>
              <Grid item xs={2} sm={3} md={3} lg={6}>
                <IconButton
                  variant="contained"
                  style={{ float: "right", marginTop: "1.5%" }}
                  onClick={() => navigate("/home")}
                >
                  <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
                </IconButton>
              </Grid>
            </Grid>
          </CardText>
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={batchActivation}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) => setBatchActivation(e.target.value)}
                >
                  <FormControlLabel
                    value="Active Batches"
                    control={<Radio size="small" />}
                    label="Active Batches"
                  />
                  <br />
                  <FormControlLabel
                    value="Archive Batches"
                    control={<Radio size="small" />}
                    label="Archive Batches"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography>Batch From Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={formState.BatchFromDate}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      "BatchFromDate",
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  error={false}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      size="small"
                      id="outlined-basic"
                      label="Outlined"
                      variant="outlined"
                      {...params}
                      error={false}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography>Batch To Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={formState.BatchToDate}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      " BatchToDate",
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  error={false}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      size="small"
                      id="outlined-basic"
                      label="Outlined"
                      variant="outlined"
                      {...params}
                      error={false}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{ marginLeft: "6px", padding: "9px" }}
              >
                Archive
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TreasurTable
              treasureList={treasureList}
              loading={invoiceLoading}
            />
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo) - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </CardBody>
      </CardHeader>
    </Card>
  );
};
export default TreasuryReview;
